import SupplierDropDownSearch from '../../SupplierDropDownSearch';
import FormHelperText from '@mui/material/FormHelperText';

export default function ProspectiveSupplierDropDownSearch(props) {
  const { commonProps, setSelectedProspectiveSuppliers, isDuplicate } = props;

  return (
    <div style={{ width: '100%', marginTop: '5px' }}>
      <SupplierDropDownSearch
        readOnly={false}
        showFilter={true}
        control={commonProps.control}
        name="suppliersNumber"
        showSingleOption={true}
        setStatusErrorMsg={commonProps.setStatusErrorMsg}
        handleInputChange={setSelectedProspectiveSuppliers}
        addSupplierError={isDuplicate}
      />
      {isDuplicate && (
        <div style={{ marginTop: '10px' }}>
          <FormHelperText
            helperText=""
            helperTextId=""
            style={{ fontSize: '14px' }}
          >
            Prospective Supplier already exists on this strategy.
          </FormHelperText>
        </div>
      )}
    </div>
  );
}
